import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { MenuItemBookState, MenuItemBookStateDay } from 'src/app/models/menu-item-book-state';
import { MenuItem } from 'src/app/models/rich-data.model';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-schedule',
  templateUrl: './schedule.component.html',
  styleUrls: ['./schedule.component.scss'],
})
export class ScheduleComponent implements OnInit {

  @Input() data: MenuItem;

  schedule: MenuItemBookState;

  days: any[] = [];
  groupedDays: any[] = [];

  accordionExpanded: boolean[] = [true];

  constructor(
    public dataServ: DataService,
    private mdlctrl: ModalController
  ) { }

  async ngOnInit() {
    this.schedule = await this.dataServ.getMenuItemBookState(this.data.id);

    this.days.push({ day: ['monday'], value: this.schedule.monday });
    this.days.push({ day: ['tuesday'], value: this.schedule.tuesday });
    this.days.push({ day: ['wednesday'], value: this.schedule.wednesday });
    this.days.push({ day: ['thursday'], value: this.schedule.thursday });
    this.days.push({ day: ['friday'], value: this.schedule.friday });
    this.days.push({ day: ['saturday'], value: this.schedule.saturday });
    this.days.push({ day: ['sunday'], value: this.schedule.sunday });


    this.days.forEach((day, index) => {
      if (index === 0) {

        this.groupedDays.push(day);
      } else {
        if (JSON.stringify(day.value) === JSON.stringify(this.groupedDays[this.groupedDays.length - 1].value)) {
          this.groupedDays[this.groupedDays.length - 1].day.push(day.day[0]);
        } else {
          this.groupedDays.push(day);
        }
      }
    });



  }

  async close() {
    await this.mdlctrl.dismiss();
  }
}
